import { Button, Icon, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import styles from 'Styles/styles.module.css';

const QuickViewButton = ({
  tooltipText = 'Quick view',
  clickHandler = () => {},
  disabled = false,
}) => {
  return (
    <Tooltip minimal disabled={!tooltipText} content={tooltipText}>
      <Button
        className={styles.primary_button_minimal}
        icon={<Icon icon={'more'} style={{ transform: 'rotate(90deg)' }} />}
        onClick={clickHandler}
        disabled={disabled}
      />
    </Tooltip>
  );
};

QuickViewButton.propTypes = {
  tooltipText: PropTypes.string,
  clickHandler: PropTypes.func,
  disabled: PropTypes.bool,
};

export default QuickViewButton;
